'use client';

import { useCallback } from 'react';
import { ToolType } from '@/lib/structured-data/tools';
import { trackToolUsage, trackToolAction } from './toolTracking';

/**
 * Custom hook for tracking tool usage
 * Provides tracking for specific user interactions only
 */
export function useToolTracking(tool: ToolType) {
  // Immediate tracking for significant actions
  const trackAction = useCallback((action: string) => {
    trackToolAction(tool, action);
  }, [tool]);
  
  // Track tool usage (when user actually uses the tool)
  const trackUsage = useCallback(() => {
    trackToolUsage(tool);
  }, [tool]);
  
  // Track calculation performed
  const trackCalculation = useCallback(() => {
    trackAction('calculation');
  }, [trackAction]);
  
  // Track currency change
  const trackCurrencyChange = useCallback(() => {
    trackAction('currency_change');
  }, [trackAction]);
  
  // Track chart interaction
  const trackChartInteraction = useCallback(() => {
    trackAction('chart_interaction');
  }, [trackAction]);
  
  return {
    trackUsage,
    trackCalculation,
    trackCurrencyChange,
    trackChartInteraction,
    trackAction
  };
}
